import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { translations } from "../../../../translate.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Checkbox, FormControlLabel, TextField, Radio, RadioGroup } from "@material-ui/core";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;

class EFAWATEERcomEditBiller extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitError: "",
            efawatercomAPI: [],
            id: this.props.data?.id || '',
            formName: this.props.data?.title || '',
            data: {},
            loadingSave: 0,
            loading: 0,
        };
    }
    componentDidMount() {
        this.getFeilds()
    }

    getFeilds = () => {
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getServiceToCategory",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                codeService: this.props.data?.codeService,
                categoryCodeId: this.props.data?.categoryId,
            }),
            headers: {
                Accept: "application/json",
            }
        })
            .then(function (response) {
                return response.json();
            })
            .then(data => {
                if (data.logout == 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                }
                else {
                    this.setState({
                        data: data.data || {},
                    });
                }
            });
    }

    handleValidSubmit = (event) => {
        this.setState({ loadingSave: 1 });
        event.preventDefault();

        // Prepare dynamic payload from state.data
        let payload = {
            type: "editServiceToCategory",
            lang: localStorage.getItem("LANG"),
            userId: localStorage.getItem("USER_ID"),
            token: localStorage.getItem("USER_TOKEN"),
            codeService: this.props.data?.codeService,
            categoryCodeId: this.props.data?.categoryId,
            codeCat: this.props.data?.catCode,
        };

        // Add dynamic fields to payload
        Object.entries(this.state.data).forEach(([fieldKey, fieldData], index) => {
            const fieldNum = index + 1;

            payload[`label${fieldNum}`] = fieldData.label || '';
            payload[`qrCodeScan${fieldNum}`] = fieldData.qrCodeScan || 0;
            payload[`isPaymentField${fieldNum}`] = fieldData.isPaymentField || 0;
        });

        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data["error"] == 1) {
                        this.setState({
                            submitError: data["errorMsg"],
                        });
                    } else {
                        this.setState({ loadingSave: 0 });
                        this.props.handleFormAction();
                    }
                }
            });
    };

    handleInputChange = (event, fieldKey) => {
        const value = event.target.value;

        const updatedData = {
            ...this.state.data,
            [fieldKey]: {
                ...this.state.data[fieldKey],
                label: value
            }
        };

        this.setState({
            data: updatedData,
            submitError: "",
        });
    };

    handleCheckboxChange = (fieldKey, propertyName) => {
        const currentValue = this.state.data[fieldKey][propertyName];

        const updatedData = {
            ...this.state.data,
            [fieldKey]: {
                ...this.state.data[fieldKey],
                [propertyName]: currentValue == 1 ? 0 : 1
            }
        };

        this.setState({
            data: updatedData,
        });
    };

    handleRadioChange = (selectedFieldKey) => {
        // Set all fields' isPaymentField to 0, then set the selected one to 1
        const updatedData = { ...this.state.data };

        Object.keys(updatedData).forEach((fieldKey) => {
            updatedData[fieldKey] = {
                ...updatedData[fieldKey],
                isPaymentField: fieldKey === selectedFieldKey ? 1 : 0
            };
        });

        this.setState({
            data: updatedData,
        });
    };

    setUpSelectOptions = (type) => {
        var list = "";
        if (type == "apiType") {
            list = this.state.efawatercomAPI.map((rowData, index) => {
                return (
                    <option value={rowData.id} key={index}>
                        {rowData.name}
                    </option>
                );
            });
        }
        return list;
    };

    render() {
        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row className="align-items-center justify-content-between">
                        <Col lg={9} md={9} sm={9} xs={9}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {" "}
                                {Strings["Edit"]} {this.state.formName}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className="text-right">
                            <HighlightOffIcon
                                onClick={this.props.handleCloseSideBar}
                                className="modal-close-icon"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="sidebar-body-view">
                    {this.state.loading == 0 && (
                        <AvForm
                            onValidSubmit={this.handleValidSubmit}
                            ref={(c) => (this.form = c)}
                            className="custom-form-group"
                        >
                            {this.state.data && this.state.data.field1 &&
                                Object.entries(this.state.data).map(([fieldKey, rowData], index) => {
                                    const fieldNum = index + 1;
                                    const qrCodeKey = 'qrCodeScan';
                                    const isPaymentKey = 'isPaymentField';

                                    return (
                                        <div
                                            key={fieldKey}
                                            style={{
                                                backgroundColor: "#f2f3f7",
                                                borderRadius: "10px",
                                                padding: "10px",
                                                marginBottom: "15px",
                                                border: "1px solid #ccc"
                                            }}
                                        >
                                            <AvField
                                                name={`${fieldKey}_label`}
                                                label={Strings[`Field ${fieldNum}`] + " *"}
                                                placeholder={Strings["Enter"] + " " + Strings[`Field ${fieldNum}`]}
                                                value={rowData.label || ''}
                                                onChange={(e) => this.handleInputChange(e, fieldKey)}
                                                errorMessage={Strings["This field is required"]}
                                                className="mb-2"
                                                style={{ lineHeight: 8.5 }}
                                            />

                                            <FormControlLabel
                                                style={{ margin: "0px" }}
                                                label={
                                                    <>
                                                        <label className="font-w-400">
                                                            {Strings["Camera Scanner"]}
                                                        </label>
                                                    </>
                                                }
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        name={`${fieldKey}_qrCodeScan`}
                                                        style={{ marginBottom: "0.5rem" }}
                                                        onChange={() => this.handleCheckboxChange(fieldKey, qrCodeKey)}
                                                        checked={rowData[qrCodeKey] == 1}
                                                    />
                                                }
                                            />
                                            <FormControlLabel
                                                style={{ margin: "0px" }}
                                                label={
                                                    <>
                                                        <label className="font-w-400">
                                                            {Strings["Is Payment Field"]}
                                                        </label>
                                                    </>
                                                }
                                                control={
                                                    <Radio
                                                        color="primary"
                                                        name="paymentField"
                                                        style={{ marginBottom: "0.5rem" }}
                                                        onChange={() => this.handleRadioChange(fieldKey)}
                                                        checked={rowData[isPaymentKey] == 1}
                                                    />
                                                }
                                            />
                                        </div>
                                    );
                                })
                            }


                            <div className="text-right mt-4">
                                {this.state.loadingSave == 1 ? (
                                    <button
                                        type="button"
                                        className="btn form-save-btn mr-1 ml-1 task-action-btn-loading"
                                    >
                                        <CircularProgress className="SaveCircularProgressColor" />{" "}
                                        {Strings["Save"]}
                                    </button>
                                ) : (
                                    <button type="submit" className="btn form-save-btn mr-1 ml-1">
                                        {" "}
                                        {Strings["Save"]}{" "}
                                    </button>
                                )}

                                <button
                                    type="button"
                                    className="btn form-cancel-btn m-l-10"
                                    onClick={this.props.handleCloseSideBar}
                                >
                                    {Strings["Cancel"]}
                                </button>
                            </div>

                            {this.state.submitError && (
                                <div className="error-text-black">
                                    <i className="flaticon2-exclamation error-icon mr-1" />{" "}
                                    {this.state.submitError}
                                </div>
                            )}
                        </AvForm>
                    )}
                    {this.state.loading == 1 && this.state.efawatercomAPI.length <= 0 && (
                        <Row>
                            <Col md={12} style={{ marginTop: "11%" }} className="text-center">
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
        );
    }
}

export default EFAWATEERcomEditBiller;
